module.exports = __webpack_public_path__ + "img/dan.68eea291.png";